export default __webpack_public_path__ + "static/media/wall-art.8ee6958a.jpg";